import _slicedToArray from "/home/runner/work/tankchecker/tankchecker/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';

var useGeolocation = function useGeolocation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      enableHighAccuracy = _ref.enableHighAccuracy,
      maximumAge = _ref.maximumAge,
      timeout = _ref.timeout;

  var callback = arguments.length > 1 ? arguments[1] : undefined;

  var _useState = useState({
    accuracy: null,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    latitude: null,
    longitude: null,
    speed: null,
    timestamp: null,
    error: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      coordinates = _useState2[0],
      setCoordinates = _useState2[1];

  useEffect(function () {
    var didCancel;

    var updateCoordinates = function updateCoordinates(_ref2) {
      var _ref2$coords = _ref2.coords,
          coords = _ref2$coords === void 0 ? {} : _ref2$coords,
          timestamp = _ref2.timestamp;
      var accuracy = coords.accuracy,
          altitude = coords.altitude,
          altitudeAccuracy = coords.altitudeAccuracy,
          heading = coords.heading,
          latitude = coords.latitude,
          longitude = coords.longitude,
          speed = coords.speed;

      if (!didCancel) {
        setCoordinates({
          accuracy: accuracy,
          altitude: altitude,
          altitudeAccuracy: altitudeAccuracy,
          heading: heading,
          latitude: latitude,
          longitude: longitude,
          speed: speed,
          timestamp: timestamp,
          error: null
        });

        if (callback instanceof Function) {
          callback({
            accuracy: accuracy,
            altitude: altitude,
            altitudeAccuracy: altitudeAccuracy,
            heading: heading,
            latitude: latitude,
            longitude: longitude,
            speed: speed,
            timestamp: timestamp,
            error: null
          });
        }
      }
    };

    var setError = function setError(error) {
      if (!didCancel) {
        setCoordinates({
          accuracy: null,
          altitude: null,
          altitudeAccuracy: null,
          heading: null,
          latitude: null,
          longitude: null,
          speed: null,
          timestamp: null,
          error: error
        });
      }
    };

    var watchId;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(updateCoordinates, setError);
      watchId = navigator.geolocation.watchPosition(updateCoordinates, setError, {
        enableHighAccuracy: enableHighAccuracy,
        maximumAge: maximumAge,
        timeout: timeout
      });
    }

    return function () {
      if (watchId) {
        navigator.geolocation.clearWatch(watchId);
      }

      didCancel = true;
    };
  }, [callback, enableHighAccuracy, maximumAge, timeout]);
  return coordinates;
};

export default useGeolocation;